const initialState = {
  loading: false,
  lists: [],

  error: null,
};
const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_CATEGORY_LIST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "SET_CATEGORY_LIST":
      return {
        ...state,
        loading: false,
        lists: action.payload,
      };

    case "SET_CATEGORY_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.err?.message,
      };
    default:
      return state;
  }
};

export default categoryReducer;
